// Add flags you want to use on the project

export const flagsAXP = [
  'flagAxpAdvancedSearch',
  'flagAxpBuilderTemplates',
  'flagAxpEmailBuilderComponentsRedesign',
  'flagAxpEmailListPosts',
  'flagAxpEmailListDiscussions',
  'flagAxpEngagementScoringPerfImprovement',
  'flagAxpJimo',
  'flagAxpUserEvents',
  'flagBuilderLazyLoadSections',
  'flagBuilderPageGlobalStorage',
  'flagBuilderRemoveColumnBackground',
  'flagBuilderUploadDownloadZip',
  'flagBuilderUploadVideo',
  'flagBuilderWeightLimitation',
] as const;

export const flagsIM = [
  'flagImEmojiPicker',
  'flagImCustomEmojiReactions',
] as const;

export default [
  ...flagsAXP,
  ...flagsIM,
  'flagActivateFrontMonitoringDatadog',
  'flagAxpBrandingAvatarToGlobalStorage',
  'flagAxpBrandingFaviconToGlobalStorage',
  'flagAxpBrandingMobileHeaderLogoToGlobalStorage',
  'flagAxpBrandingWebsiteFooterLogoToGlobalStorage',
  'flagAxpCampaignsCkDeprecation',
  'flagAxpUserListRevampWave1',
  'flagBraintree3DSecureSca',
  'flagCurrentSessionContext',
  'flagDsIsolationNewsDetailPage',
  'flagEvAblyInactivityTracker',
  'flagEvAiFormAssistantOnForums',
  'flagEvAiFormAssistantOnNews',
  'flagEvBlockContentUploadCkEditor',
  'flagEvEventsBoRevamp',
  'flagEvForumSummary',
  'flagEvGeoboxSearch',
  'flagEvGsMembershipLogo',
  'flagEvImproveSoldOutEventsFo',
  'flagEvMembershipFoPagination',
  'flagEvMentoringAdminMatch',
  'flagEvMessagingReactQuery',
  'flagEvNewEventFoCard',
  'flagEvNewsPackage',
  'flagEvNewsRevamp',
  'flagEvOrderSummaryDsEvents',
  'flagEvPaymentPageDonations',
  'flagEvPaymentPageEvents',
  'flagEvPaymentPageMemberships',
  'flagEvPaymentsMovePromocode',
  'flagEvRecaptchaToTurnstile',
  'flagEvStandaloneZoom',
  'flagEvStripeCobrandedCards',
  'flagEvStripeDirectChargeForAllCC',
  'flagEvSuperAdminReadOnly',
  'flagEvTinyMce',
  'flagEvUserPicturesToGlobalStorage',
  'flagEvVirusScanning',
  'flagEvZoomAttendanceTracking',
  'flagGoogleMapsComponent',
  'flagHivehackNotifyPeople',
  'flagMobileAppsBoOptionalAndroidServiceAccountJson',
  'flagProfileCustomHeader',
  'flagRequestUserAccountDeletion',
  'flagSuEmailSecurity',
  'flagSuNotifSignin',
  'flagUeMobileCaretFooter',
  'flagUeNewOutdatedBrowserDetection',
  'flagUeSearchDeactivateGlobal',
  'flagUjAblyClientMigration',
  'flagUjAblyInternalNotifications',
  'flagUjAiContentRecommendation',
  'flagUjAiContentRecommendationAllTypes',
  'flagUjAiContentRecommendationForumEvents',
  'flagUjAiGlobalSearch',
  'flagUjAiUserProfileSummary',
  'flagUjAnchoringComments',
  'flagUjbBiggerBadgeSize',
  'flagUjbGroupHeaderRedesign',
  'flagUjbLfPagination',
  'flagUjNotificationsCommentsImprovement',
  'flagUjNotificationsNotifyImprovement',
  'flagUjUserProfilePerf',
  'flagUjUserprofileRedesignWave1',
  'flagUjSearchLocationAnonymous',
  'flagUjUserProfileSnapshot',
  'flagUseWhitelabelCustomCertificate',
] as const;
